// Deal option names and room asset "Maximum Occupancy" text both encode occupancy as "<n>A"
// plus optional "<n>C"/"<n>T" (e.g. "2A2C") — structured numeric fields are often null here.
const OCCUPANCY_TEXT_PATTERN = /(\d+)A(?:\s*\+?\s*(\d+)([CT]))?/i;

// Also matches total-pax formats ("12 pax", "3 people/guests") and a bare number — together
// covers ~97% of real Maximum_Occupancy__c values sampled; ambiguous prose is left unparsed.
const OCCUPANCY_TOTAL_PAX_PATTERN = /(\d+)\s*(?:pax|people|persons|guests?)\b/i;
const BARE_NUMBER_PATTERN = /^\s*(\d+)\s*$/;

export interface ParsedOccupancy {
  adults: number;
  extraCount?: number;
  extraType?: 'C' | 'T';
}

export function parseOccupancyText(text?: string | null): ParsedOccupancy | undefined {
  if (!text) {
    return undefined;
  }

  const match = OCCUPANCY_TEXT_PATTERN.exec(text);
  if (!match) {
    return undefined;
  }

  return {
    adults: Number(match[1]),
    extraCount: match[2] ? Number(match[2]) : undefined,
    extraType: match[3] as 'C' | 'T' | undefined,
  };
}

export function getOccupancyPaxFromText(text?: string | null) {
  const parsed = parseOccupancyText(text);

  if (parsed) {
    return parsed.adults + (parsed.extraCount ?? 0);
  }

  const totalPaxMatch = text ? OCCUPANCY_TOTAL_PAX_PATTERN.exec(text) : null;

  if (totalPaxMatch) {
    return Number(totalPaxMatch[1]);
  }

  const bareNumberMatch = text ? BARE_NUMBER_PATTERN.exec(text) : null;

  return bareNumberMatch ? Number(bareNumberMatch[1]) : undefined;
}
